import { BuildTypes } from "tools/summaryMaker/store/types";
import createReducersFromTypes from "store/createReducersFromTypes";

export default createReducersFromTypes(BuildTypes);
